<template>
  <div>
    <multi-select
      :value="segments"
      @input="onInput"
      :multiple="true"
      placeholder="Search or add a segment"
      label="name"
      track-by="id"
      :options="options"
      :taggable="true"
      tag-placeholder="Add this as new segment"
      @tag="onAdd" />

    <segment-editor
      v-if="newSegment.id"
      :key="newSegment.id"
      :id="newSegment.id"
      :default-name="newSegment.name"
      @close="onSegmentAdded"/>
  </div>
</template>

<script>
  import _ from 'lodash';
  import uniqid from 'uniqid';
  import MultiSelect from 'vue-multiselect';
  import SegmentEditor from '../Segments/Editor';

  export default {
    name: 'SegmentPicker',
    components: {SegmentEditor, MultiSelect },

    props: {
      value: Array
    },

    data() {
      return {
        newSegment: {
          id: null,
          name: ''
        }
      };
    },

    methods: {
      onAdd(name) {
        this.newSegment = {id: uniqid(), name};
      },

      onInput(value) {
        this.$emit('input', value.map(({id}) => id));
      },

      onSegmentAdded() {
        const {id} = this.newSegment;
        if (_.some(this.options, {id})) {
          this.$emit('input', _.concat(this.value, id));
        }
        this.newSegment.id = null;
      }
    },

    computed: {
      options() {
        return this.$store.state.segments.segmentList.map(({id, name}) => ({id, name}));
      },

      segments() {
        return _.filter(this.options, ({id}) => _.indexOf(this.value, id) > -1);
      }
    }
  };
</script>

<style scoped>

</style>
